import { ICardItemResponse } from "../../services/card-list/card-list.interface";

export const actionTypes = {
  SET_CARD_SELECTED: "SET_CARD_SELECTED",
  SET_CARD_ADDED_STATUS: "SET_CARD_ADDED_STATUS",
  SET_CARD_UPDATE_INITIATED: "SET_CARD_UPDATE_INITIATED",
};

const setCardSelected = (payload: ICardItemResponse | null) => ({
  type: actionTypes.SET_CARD_SELECTED,
  payload,
});

const setCardAddedStatus = (isCardAdded: boolean) => ({
  type: "SET_CARD_ADDED_STATUS",
  payload: isCardAdded,
});
const setCardUpdateStatus = (isCardUpdateInitiated: boolean) => ({
  type: "SET_CARD_UPDATE_INITIATED",
  payload: isCardUpdateInitiated,
});


export default {
  setCardSelected,
  setCardAddedStatus,
  setCardUpdateStatus,
};
